module.exports = __webpack_public_path__ + "static/media/bird.5c35a2c3.svg";